export default class problem{
    constructor({type,title,reason,message,body, name, uploadIDs, resolved}) {
        this.type = type; // 'USER' | 'BUNDLE' | 'DATA'
        this.title = title; // Title of the section
        this.reason = reason; // Reason for the problem
        this.message = message; // Detailed message about the problem
        this.body = body; // Message to be displayed to the user
        this.uploadIDs = uploadIDs; // Array of upload IDs related to this problem
        this.name = name
        this.resolved = resolved
    }
}